import React from "react";
import { Link } from "react-router-dom";
export function Logo({
  onClick
}: {
  onClick?: () => void;
}) {
  return <Link to="/" onClick={onClick} className="flex items-center gap-3" aria-label="NEXORA Web Studio home" data-id="element-453" data-mp="wnuqtith8ux8">
      <span className="grid h-10 w-10 place-items-center rounded-xl bg-accent font-display text-lg font-bold text-white" data-id="element-454" data-mp="rus3vtj7gjq0">
        N
      </span>
      <span className="leading-none" data-id="element-455" data-mp="iveu0zr65t4r">
        <span className="block font-display text-[17px] font-semibold tracking-tight" data-id="element-456" data-mp="iwg5v6g0ejnj">NEXORA</span>
        <span className="mt-1 block font-mono text-[9px] uppercase tracking-[0.35em] text-muted" data-id="element-457" data-mp="dvabl46paobw">Web Studio</span>
      </span>
    </Link>;
}